"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TripStatusListItem = void 0;
class TripStatusListItem {
}
exports.TripStatusListItem = TripStatusListItem;
//# sourceMappingURL=trip-status-list-item.js.map